import { Alert, Row } from 'antd'
import ConvocatoriaDetails from './details'
import ConvocatoriaCityFilter from './cityFilter'

import './styles.scss'
import { ApplicationsState, AuthState, ConvocatoriasState } from '@/state'
import { useComputed } from '@preact/signals-react'

export default function ConvocatoriaContainer() {
  const canShowAlert = useComputed(() =>
    Boolean(
      AuthState.applicationPermission.value.create &&
        ApplicationsState.showCreateAlert.value
    )
  )
  if (!ConvocatoriasState.convocatorias.value.length) return null

  const handleHideALert = () => {
    ApplicationsState.showCreateAlert.value = false
  }

  return (
    <Row className='convocatoria-container'>
      {canShowAlert.value && (
        <Alert
          type='info'
          message='Para habilitar la creación de una nueva solicitud, debes seleccionar una CONVOCATORIA y un MUNICIPIO'
          closable
          className='alert-message'
          onClose={handleHideALert}
        />
      )}
      <div className='convocatoria-selector'>
        <ConvocatoriaDetails />
        <ConvocatoriaCityFilter />
      </div>
    </Row>
  )
}
